export default __webpack_public_path__ + "static/media/recommendHuman@2x.db1ee706.png";